module.exports = __webpack_public_path__ + "img/about.2280160d.jpg";